import { ITypeTicketData } from 'meta/pages/v4/typeticket'
import { SliceSelector } from 'store/types'

const getTypeTicketData: SliceSelector<ITypeTicketData | undefined, { id: number }> =
  ({ id }) =>
  (state) =>
    state.pages.typeticket.typetickets[id]

const getUserTypeTicketCollectionIdsForGivenEvent: SliceSelector<number[] | undefined, { eventId: number }> =
  ({ eventId }) =>
  (state) =>
    Object.values(state.pages.typeticket.typetickets)
      .filter((x) => x.eventId == eventId)
      .map((x) => x.typeTicketCollection?.id ?? -1)
      .filter((x) => x !== -1)

export const TypeTicketSelectors = {
  getTypeTicketData,
  getUserTypeTicketCollectionIdsForGivenEvent,
}
